import Link from 'next/link';
import React from 'react';
import { useLocale } from "@/app/components/LocaleProvider";
import { getPathWithLocale } from "@/lib/i18n";

// Заголовок секции с "view all"
export default function SectionHeader({ title, href, align = 'center' }: { title: string; href?: string, align?: 'left' | 'center' }) {
    const alignClass = align === 'left' ? 'text-left' : 'text-center';
    const locale = useLocale();

    return (
        <header>
            <h2 className={`text-3xl font-bold tracking-tight text-white/95 mt-36 max-md:mt-0 py-4 ${alignClass}`}>{title}</h2>
            {href && (
                <div className={alignClass}>
                    <Link
                        href={getPathWithLocale(href, locale)}
                        className="inline-flex min-h-6 items-center px-1.5 py-1 text-xs text-white/60 hover:text-white transition-colors"
                    >
                        View all
                    </Link>
                </div>
            )}
        </header>
    );
}
